/// <reference path="index.d.ts" />
import * as React from 'react';
import doLog from '../../common/log';

function DotContainer(props: { exposeDot: any; index: any; exposeDotParams: any; children: {}; }) {
  switch (props.exposeDot) {
    case 'data-recommend-buy':
      return (
        <div
          data-recommend-buy
          data-pos={props.index}
          data-real-ctr-param={props.exposeDotParams}
        >
          {props.children}
        </div>
      );
    case 'data-recommend-popular':
      return (
        <div
          data-recommend-popular
          data-pos={props.index}
          data-real-ctr-param={props.exposeDotParams}
        >
          {props.children}
        </div>
      );
    case 'data-recommend-yml':
      return (
        <div
          data-recommend-yml
          data-pos={props.index}
          data-real-ctr-param={props.exposeDotParams}
        >
          {props.children}
        </div>
      );
    default:
      break;
  }
}


export default function Card(props: { item: ProductList; exposeDot: any; i18n?: {}; index: any; }) {
  const {
    item,
    exposeDot,
    i18n = {},
    index,
  } = props;

  const {
    promotionPrice,
    sellPoints,
    viewsOrders,
    detailUrl,
    mainImage,
    title,
    price,
    discount,
    realCtrParam,
    clickParam,
    rts,
    moqText} = item;

  const handleClick = (clickEleType: string, clickParams: any) => () => {
    doLog(
      '/sc.details.recommendItemClick',
      'CLK',
      `click_param=${clickParams}&click_type=${clickEleType}`
    );
  };

  return (
    <DotContainer
      exposeDot={exposeDot}
      index={index}
      exposeDotParams={realCtrParam}
    >
      <a
        href={detailUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick('img', clickParam)}
      >
        <img
          className="recommend-card-img"
          src={mainImage}
          alt={title}
          title={title}
        />
      </a>
      {sellPoints?.length > 0 && <div className='sell-point'>{sellPoints.map(i => <span key={i.value}>{i.value}</span>)}</div>}
      {rts ? (
        <a
          href={detailUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick('title', clickParam)}
        >
          <div
            className="recommend-card-title recommend-card-title-line1"
            title={title}
          >
            {title}
          </div>
        </a>
      ) : (
        <a
          href={detailUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick('title', clickParam)}
        >
          <div className="recommend-card-title" title={title}>
            {title}
          </div>
        </a>
      )}
      {promotionPrice ? <div className='promotion-price'>
        <strong>{promotionPrice}</strong>
        <div className='discount'>
          <del>{price}</del>
          <span>{discount}</span>
        </div>
      </div> :
      <div className="recommend-price" title={price}>
        {price}
      </div>}
      {moqText ? (
        <div className="recommend-moq">
          {i18n["productsListView.MinOrder"]} {moqText}
        </div>
      ) : null}
      {viewsOrders && <div className='view-order'>{viewsOrders}</div>}
    </DotContainer>
  );
}